<template>
  <div class="about">
    <div class="container marketing">
      <hr class="featurette-divider">
      <h3>Payment</h3>
      <div class="row justify-content-center">
        <form :action="actionUrl" method="post" target="_top" id="paymentForm">
          <input type="hidden" name="cmd" value="_s-xclick">
          <input type="hidden" name="hosted_button_id" :value="id" id="hosted_button_id">
          <table>
            <tr><td>
              <p>Kalalaya collects tuition quarterly. Tuition is due before the 15th of the month in January, April, July, and October.
                The tuition is <b>$180</b> for dance and <b>$180</b> for music per student per quarter. Please include a <b>$10</b> late fee if paying after the 15th of the month. </p>
              <p>Include <b>all</b> family members who are students at Kalalaya in <b>one transaction.</b></p>
            </td></tr>
            <tr class="row justify-content-center"><td><input type="hidden" name="on0" value="Full Names of all the students">First & Last Names of all the students</td></tr><tr class="row justify-content-center"><td><input type="text" name="os0" maxlength="200" required></td></tr>
            <tr class="row justify-content-center"><td><input type="hidden" name="on1" value="Phone Number">Phone Number(WhatsApp Number)</td></tr><tr class="row justify-content-center"><td><input type="text" name="os1" maxlength="200" required></td></tr>
          </table>
          <br />
          <b style="color:red">This payment method is currently unavailable for use. We are working on a different payment option. Please try again later. </b>
         <!-- <span class="row justify-content-center"> <input type="image" src="https://www.paypalobjects.com/en_US/i/btn/btn_paynowCC_LG.gif" border="0" name="submit" alt="PayPal - The safer, easier way to pay online!">
            <img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1">
           </span>-->
        </form>
      </div>
      <hr>
      <hr class="featurette-divider">
      <!-- /END THE FEATURETTES -->

    </div><!-- /.container -->
  </div>
</template>
<script>
// @ is an alias to /src

export default {
  data: function () {
    return {
      // actionUrl: 'https://www.paypal.com/cgi-bin/webscr'
    }
  },
  computed: {
    actionUrl: function () {
      return this.$store.state.actionUrl
    },
    id: function () {
      return this.$store.state.payment_button_id
    }
  }
}
</script>
